import usePyqRedux from "../hooks/usePyqRedux";
import { useGetTabsList } from "../hooks/useGetTabsList";
import "./SubTabs.css";

const SubTabs = () => {
  const { pyqMainCurrentTab, pyqSubCurrentTab, setPyqSubCurrentTab } =
    usePyqRedux();
  const { data } = useGetTabsList();

  const selectedTab = data?.data?.find((tab) => {
    return tab.name == pyqMainCurrentTab.name;
  });

  return (
    <div className="pyq-subtabs-container">
      <ul className="pyq-subtabs">
        {selectedTab?.pyqSubList?.map((subtab, index) => (
          <li
            key={index}
            className={`pyq-subtab ${
              subtab.sublistName == pyqSubCurrentTab.sublistName
                ? "pyq-subtab-active"
                : ""
            }`}
            onClick={() => setPyqSubCurrentTab(subtab)}
          >
            {subtab.sublistName}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SubTabs;
